import { ArrowUpRight } from 'lucide-react'
import { useId } from 'react'
import { useI18n } from '../i18n.jsx'
import ProductFamilyIcon from './ProductFamilyIcon.jsx'

export default function ProductFamilies({ products }) {
  const { t } = useI18n()
  const gradientPrefix = useId().replaceAll(':', '')
  return <section id="product-families" className="product-family-band" aria-labelledby="product-families-title">
    <div className="section-inner">
    <div className="section-heading product-family-heading"><h2 id="product-families-title">{t('site.range_title')}</h2></div>
    <ol className="product-family-list">
      {products.map((product) => <li key={product.id}><a href={`#product-${product.id}`} style={{ '--family-gradient': `url(#${gradientPrefix}-${product.id})` }}>
        <ProductFamilyIcon product={product.id} className="family-icon" strokeWidth={1} aria-hidden="true"><defs><linearGradient id={`${gradientPrefix}-${product.id}`} gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="24" y2="24"><stop offset="0%" stopColor="#075dd5" /><stop offset="55%" stopColor="#0082e5" /><stop offset="100%" stopColor="#00bad8" /></linearGradient></defs></ProductFamilyIcon>
        <h3>{product.title}</h3>
        <ArrowUpRight size={19} strokeWidth={1.5} aria-hidden="true" />
      </a></li>)}
    </ol>
    </div>
  </section>
}
